<template>
  <div>
    <div class="is-print-hide">
      <el-table
        stripe
        :data="List"
        size="medium"
        style="width: 100%"
        :cell-class-name="selectable"
        @selection-change="handleSelectionChange"
        header-row-class-name="common-table-header"
        row-class-name="common-table-row"
        class="is-print-hide common-table"
        :border="false"
      >
        <el-table-column prop="name" label="姓名" width="94" class-name="name-box">
          <template slot-scope="scope">
            <img v-if="scope.row.companyRepresentative" :src="require('@/assets/img/tip.png')" class="tip" alt="" />
            <img
              v-if="scope.row.isPlatformPharmacist"
              :src="require('@/assets/img/zhiyun_tip.png')"
              class="tip"
              alt=""
            />
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="登录名" width="115"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="115"></el-table-column>
        <el-table-column prop="storeList" label="门店">
          <template slot-scope="{ row: { storeList } }">
            <div>
              <el-tooltip effect="dark" :open-delay="500" :content="joinStoreList(storeList)" placement="top">
                <div class="stores">
                  <span class="names">
                    {{ joinStoreList(storeList) }}
                  </span>
                  <span class="count" v-if="storeList">共{{ storeList.length }}家</span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="disableStatusName" label="启用/禁用" width="94">
          <template slot-scope="scope">
            <span>{{ scope.row.disableStatusName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="状态" width="94">
          <template slot-scope="scope">
            <span>{{ scope.row.statusName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="roleList" label="角色" width="148">
          <template slot-scope="{ row: { roleList } }">
            <div>
              <el-tooltip effect="dark" :open-delay="500" :content="joinRoleList(roleList)" placement="top">
                <span>{{ joinRoleList(roleList, companyRepresentative) }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot="header" slot-scope="scope">
            <div class="hnamecenter">操作</div>
          </template>
          <template slot-scope="scope">
            <!-- <el-row> -->
            <div class="handler">
              <div class="btn global_common_text_hover" @click="showStaff(scope.row.id)">
                <span>查看</span>
              </div>
              <div
                class="btn global_common_text_hover"
                @click="editorStaff(scope.row.id)"
                v-if="scope.row.editable == 1"
              >
                <span>编辑</span>
              </div>
              <div
                class="btn global_common_text_hover"
                @click="confirmStaff(scope.row)"
                v-if="deletable(scope.row.id, scope.row.roleList)"
              >
                <span style="color: #e0514c">删除</span>
              </div>
            </div>
            <!-- </el-row> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getRoleType, hasRole } from '@/util/index';

export default {
  name: 'StaffManagementTable',
  props: {
    List: Array,

    default: () => []
  },
  data() {
    return {
      pcListConfig: {
        dispense: false,
        dispatch: false
      },
      companyRepresentative: '公司负责人'
    };
  },
  computed: {
    userId() {
      return this.$store.getters.userId;
    },
    // 当前角色
    currentRoleType() {
      return this.$store.getters.roleType;
    }
  },
  methods: {
    // 是否可以删除
    deletable(id, roleList) {
      // 目前逻辑是自己不能删除自己，后端要等超过三个字端才放在后端
      let { userId, currentRoleType } = this;
      // 获取被删除人的角色
      let targetRoleType = getRoleType(roleList);
      // 自己不能删除自己
      if (id != userId) {
        // 店长或者大区负责人不能删除公司负责人和远程药师
        // 如果是店长或者大区负责人，不具有公司负责人角色
        if ((hasRole(currentRoleType, 'd') || hasRole(currentRoleType, 'c')) && !hasRole(currentRoleType, 'a')) {
          // 被删除者是公司负责人或者远程药师
          if (hasRole(targetRoleType, 'b') || hasRole(targetRoleType, 'a')) {
            return false;
          }
        }
        return true;
      }
      return false;
    },
    GendrugstorePharmacist(List) {
      // 渲染驻店药师
      return List.join('，');
    },
    renderText(st) {
      // 根据状态渲染文字
      if (st == 0) {
        return '待审核';
      }
      if (st == 1) {
        return '已审核';
      }
      if (st == -1) {
        return '重新认证';
      }
    },
    editorStaff(id) {
      this.$router.push('/staffManagement/editorStaff/' + id);
    },
    showStaff(id) {
      this.$router.push('/staffManagement/showStaff/' + id);
    },
    // 确认职员
    confirmStaff(userDetail) {
      let { userId, isPlatformPharmacist } = userDetail;
      // 是否是智云专配远程药师
      if (isPlatformPharmacist) {
        this.$message('智云专配远程药师无法删除');
        return;
      }
      this.$confirm('确定删除该店员吗？删除后不可撤销', '删除职员', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'confirm',
        center: true
      })
        .then(() => {
          this.deleteStaff(userId);
        })
        .catch(() => {});
    },
    // 删除店员
    deleteStaff(userId) {
      let { List } = this;
      Fetch.deleteUser({ userId: userId })
        .then(res => {
          let index = List.findIndex(item => item.userId === userId);
          List.splice(index, 1);
          this.List = List;
          this.$message('删除成功');
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 下载pdf
    downLoad(name, id) {
      const token = Util.getUserInfo().token;
      const query = `pk=${token}&pid=${id}`;
      // 带着token和id直接下载pdf
      Util.download(`${Util.getApiRoot}/pr/load/pdf?${query}`);
    },
    handleSelectionChange(val) {
      let ids = '';
      val.forEach(val => {
        if (val.prescriptionTotalStatus == 2) {
          if (ids) {
            ids += ',' + val.id;
          } else {
            ids += val.id;
          }
        }
      });
      this.$emit('selectChange', ids);
    },
    selectable({ row }) {
      if (row.prescriptionTotalStatus != 2) {
        return 'unselect';
      }
    },
    // toJoinSrt(array, key, code, filter) {
    //   if (array && array.length > 0) {
    //     let strs = array.reduce((str, value) => {
    //       if (str) {
    //         return `${str}${code}${value[key]}`;
    //       } else {
    //         if (value[key] != filter) {
    //           return `${value[key]}`;
    //         } else {
    //           return str;
    //         }
    //       }
    //     }, '');
    //     return strs;
    //   } else {
    //     return '';
    //   }
    // },
    joinStoreList(storeList, limit) {
      return storeList
        ? (limit ? storeList.filter((store, i) => i < 5) : storeList).map(store => store.name).join(',')
        : '';
    },
    joinRoleList(roleList, filter = '') {
      return roleList
        ? (filter ? roleList.filter(role => role.name !== filter) : roleList)
            .map(role => Constant.roleType[role.code])
            .join(',')
        : '';
    }
  }
};
</script>

<style lang="scss"></style>
<style lang="scss" scoped>
.handler {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  .btn {
    // color: #1E8DFF;
    font-size: 12px;
    margin-right: 10px;
    text-align: center;
    cursor: pointer;
    &:nth-last-child(1) {
      margin-right: 0;
    }
  }
}
.addressText {
  width: 241px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.name-box {
  position: relative;
  .tip {
    position: absolute;
    top: 0;
    left: 0;
    width: 36px;
    height: 12px;
  }
}
.hnamecenter {
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  text-align: center;
}

.stores {
  display: flex;

  .names {
    margin-right: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 95%;
  }

  .count {
    flex: 1;
  }
}
</style>
